<div class="card">
  <h2 class="title px-6 py-4">{{ title }}</h2>
  <mat-divider [vertical]="false"></mat-divider>

  <!-- Responsable actuel (facture) : réponse directe à « qui doit agir maintenant ? » -->
  <div *ngIf="showOwner" class="px-6 pt-4">
    <div *ngIf="currentOwner; else noCurrentOwner" class="flex items-center gap-3 rounded-lg bg-primary/10 h-9">
      <span
        *ngIf="showCurrentOwnerAvatar"
        class="flex items-center justify-center rounded-full text-white text-xs leading-none font-semibold w-9 h-9 shrink-0"
        [style.background]="currentOwner.color"
      >
        {{ currentOwner.initials }}
      </span>
      <div class="flex flex-col min-w-0">
        <span class="text-xs text-secondary leading-none mb-0.5">En charge</span>
        <span class="font-medium truncate leading-tight">{{ currentOwner.name }}</span>
      </div>
    </div>
    <ng-template #noCurrentOwner>
      <div class="flex items-center gap-2 rounded-lg bg-green-100 text-green-800 px-3 py-2">
        <mat-icon class="icon-sm">check_circle</mat-icon>
        <span class="text-sm font-medium">Aucune action requise</span>
      </div>
    </ng-template>
  </div>

  <ul
    *ngIf="entries?.length; else emptyState"
    @stagger
    class="px-6 py-4 overflow-y-auto"
    [style.max-height]="maxHeight"
  >
    <li *ngFor="let entry of entries; let last = last" class="relative flex gap-3">
      <!-- rail: dot + connecting line -->
      <div class="flex flex-col items-center">
        <span class="mt-[6px] h-2 w-2 rounded-full bg-primary flex-none"></span>
        <span *ngIf="!last" class="w-px flex-1 bg-gray -mb-2"></span>
      </div>
      <!-- content -->
      <div class="flex-1 min-w-0 pb-4 flex justify-between gap-2" [class.pb-0]="last">
        <div class="min-w-0">
          <p class="font-medium m-0 leading-snug">{{ entry.title }}</p>
          <p *ngIf="entry.subtitle" class="text-secondary text-sm m-0">{{ entry.subtitle }}</p>

          <ng-container *ngIf="entry.description">
            <!-- [innerHTML] est assaini par défaut via DomSanitizer (scripts retirés). -->
            <p
              *ngIf="descriptionAsHtml; else plainDescription"
              class="text-secondary text-sm m-0"
              [innerHTML]="entry.description"
            ></p>
            <ng-template #plainDescription>
              <p class="text-secondary text-sm m-0">{{ entry.description }}</p>
            </ng-template>
          </ng-container>

          <!-- Qui devient EN CHARGE : mis en avant, avatar + initiales (facture) -->
          <div *ngIf="entry.inChargeTracked" class="mt-1.5 flex items-center gap-2">
            <ng-container *ngIf="entry.inCharge as inCharge; else nobodyInCharge">
              <span
                *ngIf="showOwnerAvatar"
                class="flex items-center justify-center rounded-full text-white text-xxs leading-none font-semibold w-6 h-6 shrink-0"
                [style.background]="inCharge.color"
              >
                {{ inCharge.initials }}
              </span>
              <span class="text-xs font-medium">En charge : {{ inCharge.name }}</span>
            </ng-container>
            <ng-template #nobodyInCharge>
              <span class="text-xs text-secondary italic">Aucune action requise</span>
            </ng-template>
          </div>

          <!-- Qui a DÉCLENCHÉ l'événement : discret -->
          <p *ngIf="entry.actor" class="text-secondary text-xs m-0 mt-0.5">
            {{ entry.actor.label }}
            <ng-container *ngIf="entry.actor.name">{{ entry.actor.name }}</ng-container>
          </p>
        </div>
        <span class="self-start whitespace-nowrap text-secondary text-xs">
          {{ entry.date | date: "dd/MM/yy 'à' HH:mm" }}
        </span>
      </div>
    </li>
  </ul>

  <ng-template #emptyState>
    <p class="px-6 py-4 text-secondary text-sm m-0">Aucun historique</p>
  </ng-template>
</div>
